import { FC } from 'react';
import { ForSaleStrings } from '~js/React/types/ForSaleString';

const BiddingPing: FC = () => {
  return (
    <div className="w-full mb-2">
      <div className="flex items-center mb-0">
        <div className="flex h-2 w-2 relative mr-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white lg:bg-white bg-opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-white lg:bg-white"></span>
        </div>
        <span className="text-tiny">{ForSaleStrings.Bidding}</span>
      </div>
    </div>
  );
};
export default BiddingPing;
